<div class="container">
  <div class="heading">
    @if (showStepNumber) {
      <h1 class="circle-header">
        <div class="circle">{{ stepNumber }}</div>
      </h1>
    }
    <div>
      <h1 class="title" [class.sub-title]="subTitle !== undefined">
        <ng-content></ng-content>
      </h1>
      @if (subTitle !== undefined) {
        <h4 class="title">{{ subTitle }}</h4>
      }
    </div>
  </div>
</div>
